import React from 'react'
import { AppMode, dark_mode_primary } from './values';
import { Link } from 'react-router-dom/cjs/react-router-dom';

export function PageNotFound({ appMode }) {
    return (
        <div className={`flex items-center justify-center min-h-screen ${appMode === AppMode.LIGHT ? '' : dark_mode_primary}`}>
            <div className={`max-w-4xl w-full px-6 py-12 ${appMode === AppMode.LIGHT ? 'bg-white shadow-xl' : dark_mode_primary + ' shadow-lg shadow-gray-800'} rounded-lg`}>
                <div className={`flex flex-col md:flex-row items-center`}>
                    <div className={`w-full md:w-1/2 pr-8`}>
                        <h1 className={`text-6xl font-bold ${appMode === AppMode.LIGHT ? 'text-gray-800' : 'text-gray-200'} mb-4`}>404</h1>
                        <h2 className={`text-2xl font-semibold ${appMode === AppMode.LIGHT ? 'text-gray-600' : 'text-gray-400'} mb-4`}>Page Not Found</h2>
                        <p className={`text-gray-500 mb-8`}>We're sorry, but the page you're looking for doesn't exist or has been moved.</p>
                        <div className={`flex flex-col sm:flex-row gap-4`}>
                            <Link to="/" className={`px-6 py-3 bg-blue-600 text-white font-semibold rounded-md hover:bg-blue-700 transition duration-300 ease-in-out text-center`}>Return Home</Link>
                            <button onClick={() => window.history.back()} className={`px-6 py-3 bg-gray-200 text-gray-700 font-semibold rounded-md hover:bg-gray-300 transition duration-300 ease-in-out`}>Go Back</button>
                        </div>
                    </div>
                    <div className={`w-full md:w-1/2 mt-8 md:mt-0`}>
                        <img src="https://images.unsplash.com/photo-1613310023042-ad79320c00ff?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80" className={`w-full h-auto`} alt='' />
                    </div>
                </div>
            </div>
        </div>
    );
}